(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["made-in-pdp-urgency"] && !Shopify.designMode) return;
  try {
    (function () {
    function tick(el) {
      var end = parseInt(el.getAttribute('data-mi-pdp-countdown'), 10);
      var ms = end - Date.now();
      if (ms <= 0) { el.hidden = true; return; }
      var d = Math.floor(ms / 864e5), h = Math.floor((ms % 864e5) / 36e5), m = Math.floor((ms % 36e5) / 6e4);
      el.textContent = 'ينتهي عرض اليوم الوطني بعد ' + (d > 0 ? d + ' يوم و ' : '') + h + ' ساعة و ' + m + ' دقيقة';
    }
    function scan() {
      document.querySelectorAll('[data-mi-pdp-countdown]').forEach(function (el) {
        if (el.dataset.miPdpBound) return;
        el.dataset.miPdpBound = '1';
        tick(el);
        setInterval(function () { tick(el); }, 60000);
      });
    }
    document.addEventListener('DOMContentLoaded', scan, { once: true });
    document.addEventListener('shopify:section:load', scan);
    scan();
  })();
  } catch(e) { console.error(e); }
})();

})();
